import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import Layout from "web/components/Layout";
import Breadcrumb from "web/components/Breadcrumb";
import styles from "./details.module.scss";
import PalletsSidebar from "web/components/PalletsSidebar";
import { fetchLanguageContentNew } from "redux/actions/language";
import Need from "./Need"
import Inventory from "./Inventory"

const Details = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const urlObject = useSelector(
    (state) => state.urlParameters.details
  );
  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const [pageId, setPageId] = useState("");
  const [myPostType, setMyPostType] = useState();
  const [myPostTypeBreadCrumb, setMyPostTypeBreadCrumb] = useState();

  useEffect(() => {
    const { location } = props;
    const queryParams = new URLSearchParams(location.search);
    if (!localStorage.getItem("token")) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      if (queryParams.get("id")) {
        setMyPostType(queryParams.get("postType"));
        // fetchMyAPI(queryParams.get("id"), queryParams.get("postType"));
        setPageId(queryParams.get("id"));

        if (queryParams.get("postType") === "PostInventory") {
          setMyPostTypeBreadCrumb("Pallet Offers");
        } else if (queryParams.get("postType") === "PostLoad") {
          setMyPostTypeBreadCrumb("Pallet Needs");
        }

        if (queryParams.get("prevPage") === "bid") {
          setMyPostTypeBreadCrumb("My Bids on Pallet Needs");
        } else if (queryParams.get("prevPage") === "offer") {
          setMyPostTypeBreadCrumb("My Offers on Pallet Inventory");
        }
      } else {
        if (urlObject) {
          setMyPostType(urlObject.postType);
          // fetchMyAPI(urlObject.id, urlObject.postType);
          setPageId(urlObject.id);


          if (urlObject.postType === "PostInventory") {
            setMyPostTypeBreadCrumb('Pallet Offers')
          } else if (urlObject.postType === "PostLoad") {
            setMyPostTypeBreadCrumb("Pallet Needs")
          }

          if (urlObject.postType === "bid") {
            setMyPostTypeBreadCrumb('My Bids on Pallet Needs')
          } else if (urlObject.postType === "offer") {
            setMyPostTypeBreadCrumb("My Offers on Pallet Inventory")
          }
        }
      }
    }
  }, []);


  useEffect(() => {
    if (myPostTypeBreadCrumb === "Pallet Offers") {
      setMyPostTypeBreadCrumb(pageLanguageContents?.Breadcrumb[2]?.PalletOffers);
    } else if (myPostTypeBreadCrumb === "Pallet Needs") {
      setMyPostTypeBreadCrumb(pageLanguageContents?.Breadcrumb[1]?.PalletNeeds);
    }
  }, [pageLanguageContents]);


  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
      eventType: "Link",
    },
    {
      name: myPostTypeBreadCrumb,
      link: "",
      eventType: "Click",
    },
  ];
 
  return (
    <>{myPostType && <Layout topBarViewMobile={"hide"} 
    userType="Buyer"
    selectedSearch={myPostType === "PostLoad"?"PostLoad":"PostInventory"}
    >
      {/* {loaderVisible && <Spinner />} */}
      {(
        <div className={styles.wrapper}>
          <Breadcrumb
            breadcrumbArr={breadcrumbMapArr}
            selected={pageLanguageContents?.Breadcrumb[4]?.Details}
            title=""
          />
          <div className={styles.productDetail}>
            <SectionWrapper>
              <div className="pd-right-nav">
                <PalletsSidebar />
              </div>
              { myPostType === "PostLoad" && <Need  postType={myPostType} pageId={pageId} pageLanguageContents={pageLanguageContents}/>}
              { myPostType === "PostInventory" && <Inventory postType={myPostType} pageId={pageId} pageLanguageContents={pageLanguageContents}/>}
              { !myPostType && <span>Undefined post Type</span>}
            </SectionWrapper>
          </div>
        </div>
      )}
    </Layout>
}</>
  )
};

export default Details;

const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 237px 1fr;
  grid-column-gap: 46px;
  @media (max-width: 1250px) {
    grid-template-columns: 1fr;
    .pd-right-nav {
      display: none;
    }
  }

  @media (max-width: 767px) {
  }
`;